import { ColorObjectType } from '../types/style'

const COLOR_OBJ: ColorObjectType = {
  secondary: {
    backgroundColor: 'background.keywordSecondary',
    color: 'text.darkNavy900',
    padding: '2px 4px',
    borderColor: 'border.keywordSecondary'
  },
  primary: {
    backgroundColor: 'background.keywordPrimary',
    padding: '2px',
    borderColor: 'border.keywordPrimary'
  },
  other: {
    backgroundColor: 'background.keywordOther',
    borderColor: 'border.keywordOther'
  }
}

const getChipColorConfiguration = (color: string) => COLOR_OBJ[color] ?? {}

export default getChipColorConfiguration
